import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import classNames from 'classnames';

import { StandardBtn, PremiumBtn, FreeBtn } from 'rebook/apps/base/components/BtnSubscriptionIcon';
import BookCover from 'rebook/apps/books/components/BookCover';
import BookRating from 'rebook/apps/books/components/BookRating';
import { BOOK_STATUSES_TITLE } from 'rebook/apps/books/constants';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import { Author } from 'rebook/apps/catalog/models';
import { Book } from 'rebook/apps/books/models';

import styles from './style.scss';


const getDeleteButton = (handleDelete, book) => (
  <div className={classNames(styles.deleteButton, 'jest-delete-book-button')}
    onClick={() => {
      handleDelete(book);
      ga('send', 'event', {
        eventCategory: 'Shelves',
        eventAction: 'DeleteBookFromShelf',
        eventLabel: 'Shelf',
      });
    }} />
);

const ContextBookCard = ({
  book, order, isAudio, shouldShowAvailable,
  linkCallback, handleDelete, showDeleteButton,
}) => {
  const {
    rating: bookRating,
    reading_status: readingStatus,
  } = book;
  book = new Book(book);
  const bookType = get(book, 'type', 'text');
  const mainAuthor = book.main_author ? new Author(book.main_author) : null;
  const isAudioBook = bookType === 'audio' || isAudio;
  const audioBookImageHeight = isAudioBook ? '88' : '128';

  const mapReadingStatus = readingStatus || 0;
  const status = bookType.length ? BOOK_STATUSES_TITLE[bookType][mapReadingStatus] : '';

  const isAvailableOnlyUser = get(book, 'available_for_user_only', false);

  return (
    <div className={styles.book}>
      <div className={styles.bookCover}>
        {shouldShowAvailable
          ? (
            <BookCover
              book={book}
              isAvailableOnlyUser={isAvailableOnlyUser}
              linkCallback={linkCallback}
              isAudioBook={isAudioBook}
              height={audioBookImageHeight} />
          )
          : (
            <BookCover
              book={book}
              isAudioBook={isAudioBook}
              height={audioBookImageHeight} />
          )
        }
      </div>
      <div className={styles.bookDetail}>
        <div className={styles.bookData}>
          {(order > 0 || status) && (
            <div className={styles.info}>
              {order > 0
                ? <div className={styles.bookOrder}>{order}</div>
                : null
              }
              {status
                ? <div className={styles.bookStatus}>{status}</div>
                : null
              }
            </div>
          )}
          <div className={styles.bookTitle}>
            <Link to={book.getLink()}>
              <MultilineEllipsisText maxLinesCount={2}>{book.name}</MultilineEllipsisText>
            </Link>
          </div>
          {mainAuthor && (
            <Link to={mainAuthor.getLink()} className={styles.bookAuthor}>
              <MultilineEllipsisText maxLinesCount={3}>{mainAuthor.cover_name}</MultilineEllipsisText>
            </Link>
          )}
        </div>
        <div className={styles.bookTools}>
          <div className={styles.bookRating}>
            <BookRating
              value={bookRating.rating}
              isTiny
              showNumericValue
              votes={bookRating.votes} />
          </div>
          {(book.subscription_id === 2 || book.subscription_id === 3) && (
            <div className={styles.subscriptionContainer}>
              <PremiumBtn width="32" height="32" />
              {showDeleteButton && getDeleteButton(handleDelete, book)}
            </div>
          )}
          {book.subscription_id === 1 && (
            <div className={styles.subscriptionContainer}>
              <StandardBtn width="28" height="28" />
              {showDeleteButton && getDeleteButton(handleDelete, book)}
            </div>
          )}
          {!book.subscription_id && (
            <div className={styles.subscriptionContainer}>
              <FreeBtn />
              {showDeleteButton && getDeleteButton(handleDelete, book)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ContextBookCard.propTypes = {
  book: PropTypes.shape({
    absolute_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    read_count: PropTypes.number,
    main_author: PropTypes.shape({
      cover_name: PropTypes.string,
      absolute_url: PropTypes.string,
    }),
    rating: PropTypes.shape({
      rating: PropTypes.number.isRequired,
      votes: PropTypes.number.isRequired,
    }).isRequired,
    order: PropTypes.number,
  }),
  order: PropTypes.number,
  shouldShowAvailable: PropTypes.bool,
  handleDelete: PropTypes.func,
};

ContextBookCard.defaultProps = {
  order: null,
  shouldShowAvailable: false,
};

export default ContextBookCard;
